<template>
  <td
    :class="classes"
    class="text-left bg-base-0 px-2 py-3 border-t border-b border-transparent"
    @click="$emit('click', $event)"
  >
    <slot />
  </td>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    showOverXlColumns: {
      type: Array,
      default: () => [
        'createdAt',
        'counter',
        'presentButton',
      ],
    },
    showOver2xlColumns: {
      type: Array,
      default: () => [
        'owner',
        'onlineCount',
      ],
    },
  },
  data() {
    return {
      classes: {
        'hidden xl:table-cell': this.showOverXlColumns.includes(this.name),
        'hidden 2xl:table-cell': this.showOver2xlColumns.includes(this.name),
      },
    }
  },
}
</script>
